import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export default function AssetsPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">知识资产</h1>
        <p className="mt-1 text-sm text-muted-foreground">客户需求、内容资产、案例证据、模板和复盘</p>
      </div>
      <Card>
        <CardHeader>
          <CardTitle>资产概览</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">功能和图表即将实现。</p>
        </CardContent>
      </Card>
    </div>
  );
}